<template>
  <!-- SIDE PANEL -->
  <div class="vx-col bg-grey lg:h-full w-full p-0">
    <!-- SIDE PANEL CONTENT -->
    <SidePanelContent :studentEnrollDetail="studentEnrollDetail"
                      :courseOutlineUnits="courseOutlineUnits"
                      :courseOutlineUnitLoading="courseOutlineUnitLoading"
                      :handlerTopicClick="handlerTopicClick"
                      :handlerStartTestClick="handlerStartTestClick"
                      :triggerLoading="triggerLoading">
    </SidePanelContent>
  </div>
</template>

<script>
import SidePanelContent from "./content.vue";

export default {
  name: 'ClassContent',
  props:[
    'studentEnrollDetail',
    'sidePanelActive',
    'courseOutlineUnits',
    'courseOutlineUnitLoading',
    'handlerTopicClick',
    'handlerStartTestClick',
    'triggerLoading',
  ],
  components: {
    SidePanelContent
  },
}
</script>

<style>
.side-panel {
  overflow: hidden;
}
</style>
